/*
  This hook encapsulates a toggle logic

  Used like - const [isOpen, toggle] = useToggle()
*/

import { useState } from 'react';

function useToggle(initial = false) {
  const [isOpen, setOpen] = useState(initial);
  const toggle = () => {
    setOpen(!isOpen);
  };
  return [isOpen, toggle];
}

export default useToggle;
